import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import { bool, func, number, string } from 'prop-types'
import FilterCheckbox from './filter-checkbox'
import { Swatch, SwatchRoot } from './filters.styled'

const FilterType = ({
	active = false,
	count,
	hex,
	id,
	label: _label,
	defaultLabel,
	loading,
	onApplyFilter,
	showCountOnOption,
	type,
	src,
	...props
}) => {
	const label = _label || defaultLabel

	if (type === 'image' || type === 'hex') {
		return (
			<Swatch
				disabled={loading}
				hex={hex}
				inlineLabel={showCountOnOption && count ? label + ' (' + count + ')' : label}
				key={id}
				label={label}
				onChange={() => onApplyFilter(id, label)}
				selected={active}
				src={src && mediaUrl(src)}
				value={label}
				rootProps={SwatchRoot}
				className={label.toLowerCase() == 'white' || label.toLowerCase() == 'bianco' ? 'with-border' : ''}
				{...props}
			/>
		)
	} else {
		return (
			<FilterCheckbox
				checked={active}
				disabled={loading}
				key={id}
				label={
					<>
						{label} {showCountOnOption && count && <span style={{ marginLeft: 5 }}>{'(' + count + ')'}</span>}
					</>
				}
				name={id}
				id={id}
				labelValue={label}
				onChange={onApplyFilter}
				{...props}
			/>
		)
	}
}

FilterType.propTypes = {
	active: bool,
	count: number,
	hex: string,
	id: string.isRequired,
	image: string,
	label: string.isRequired,
	loading: bool,
	onApplyFilter: func,
	showCountOnOption: bool,
	type: string.isRequired,
}

export default FilterType
